import { ProductItem } from "@project/product-item";
import { Expose, Type } from "class-transformer";
import { IsArray } from "class-validator";

export class Regard7000PlusConfiguration {
  @IsArray()
  @Expose({ name: "dockingStations" })
  @Type(() => ProductItem)
  private readonly _dockingStations: ProductItem[];

  @IsArray()
  @Expose({ name: "inputModules" })
  @Type(() => ProductItem)
  private readonly _inputModules: ProductItem[];

  @IsArray()
  @Expose({ name: "relayModules" })
  @Type(() => ProductItem)
  private readonly _relayModules: ProductItem[];

  @IsArray()
  @Expose({ name: "gatewayModules" })
  @Type(() => ProductItem)
  private readonly _gatewayModules: ProductItem[];

  @IsArray()
  @Expose({ name: "terminalBlocks" })
  @Type(() => ProductItem)
  private readonly _terminalBlocks: ProductItem[];

  @IsArray()
  @Expose({ name: "dashboards" })
  @Type(() => ProductItem)
  private readonly _dashboards: ProductItem[];

  constructor(
    dockingStations: ProductItem[] = [],
    inputModules: ProductItem[] = [],
    relayModules: ProductItem[] = [],
    gatewayModules: ProductItem[] = [],
    terminalBlocks: ProductItem[] = [],
    dashboards: ProductItem[] = [],
  ) {
    this._dockingStations = dockingStations;
    this._inputModules = inputModules;
    this._relayModules = relayModules;
    this._gatewayModules = gatewayModules;
    this._terminalBlocks = terminalBlocks;
    this._dashboards = dashboards;
  }

  get dockingStations(): Regard7000PlusConfiguration["_dockingStations"] {
    return this._dockingStations;
  }

  get inputModules(): Regard7000PlusConfiguration["_inputModules"] {
    return this._inputModules;
  }

  get relayModules(): Regard7000PlusConfiguration["_relayModules"] {
    return this._relayModules;
  }

  get gatewayModules(): Regard7000PlusConfiguration["_gatewayModules"] {
    return this._gatewayModules;
  }

  get terminalBlocks(): Regard7000PlusConfiguration["_terminalBlocks"] {
    return this._terminalBlocks;
  }

  get dashboards(): Regard7000PlusConfiguration["_dashboards"] {
    return this._dashboards;
  }
}
